<template>
  <section  class="background">
    <header>
      <div class="image">
      <img width="250" src="../image/未命名-1.png" alt="">
    </div>
  </header>
    <monster-player></monster-player>
  </section>
</template>

<style scoped>
h1{
  text-align: center;
  font-size: 40px;
}
.background{
  box-shadow: 0 0 0 3px rgb(167, 97, 39);
  border: solid 6px rgb(255, 217, 93);
  border-radius: 2rem;
  margin: 25px;
  background: rgb(255, 251, 244);;
}

.image{
  display: flex;
  justify-content: center;
  margin: 3rem 0 2rem 0 ;
}
</style>